import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { IContactType } from '@/domain/contact-type.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_cliente;

export const insert = (data: IContactType): Promise<IContactType> => {
  return axios.post(`${url_api_base}/contact-type`, data, headers());
};

export const update = (data: IContactType): Promise<IContactType> => {
  return axios.patch(`${url_api_base}/contact-type/${data.id}`, data, headers());
};

export const get = (id: string): Promise<IContactType> => {
  const url = `${url_api_base}/contact-type/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<IContactType>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/contact-type${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const listActive = (): Promise<IContactType[]> => {
  const url = `${url_api_base}/contact-type/list-active`;

  return axios.get(url, headers()).then((res) => res?.data);
};
